/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_Card_Start_LabelInputs */

const en_company_jobs_card_start_label = /** @type {(inputs: Company_Jobs_Card_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start:`)
};

const de_company_jobs_card_start_label = /** @type {(inputs: Company_Jobs_Card_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start:`)
};

/**
* | output |
* | --- |
* | "Start:" |
*
* @param {Company_Jobs_Card_Start_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_card_start_label = /** @type {((inputs?: Company_Jobs_Card_Start_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_Card_Start_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_card_start_label(inputs)
	return en_company_jobs_card_start_label(inputs)
});